import { Component, OnInit } from '@angular/core';
import { AuthorizationService } from '../authorization.service';

@Component({
  selector: 'app-oidc-call-back',
  standalone: true,
  templateUrl: './oidc-call-back.component.html',
})
export class OidcCallBackComponent implements OnInit {

  constructor(readonly authService: AuthorizationService) {  
    console.info('oidc')
   }

  ngOnInit() {
    console.info('ngOnInit called');
  }

}
